module.exports = __webpack_public_path__ + "media/images/svg/circle-0945e1a7851e8fc2f899c03a8f5e8e25.svg";